module.exports = __webpack_public_path__ + "static/media/panorama-360-nordic-style-family-bedroom-space-01-3d-model-max.f673abdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/panorama-360-nordic-style-family-bedroom-space-01-3d-model-max.jpg
// module id = 565
// module chunks = 0